import React, { useRef } from 'react';
import ProgressLink from 'chameleon/src/components/assign/AssignManageForm/sections/ProgressLink';
import get from 'lodash/get';

const AlreadyAssignedSection = ({
  inProgressAssignments,
  router,
  isAssessmentForm,
  studentsBySection,
}) => {
  const getProgressRoute = (params, isPreApSubject) => {
    const { subject } = params;
    const assessmentsRoute = isPreApSubject ? 'assessments' : 'assignments';
    return `/${subject}/${assessmentsRoute}/progress/:assignmentId`;
  };
  const progressRoute = useRef(
    isAssessmentForm ? getProgressRoute(router.params, false) : null,
  );
  return (
    <div className="my-4.2 p-4">
      <span className="text-16 font-bold">Already Assigned:</span>
      <ul className="list-none p-0 m-0 pt-4">
        {inProgressAssignments.map(
          ({
            id: assignmentId,
            sub_group_students: subGroupStudents = [], // Default to an empty array if undefined
            section_name: sectionName,
            section_id: sectionId,
          }) => {
            const sectionStudents = studentsBySection[sectionId] || [];
            const firstStudent = sectionStudents.find(
              ({ id }) =>
                Number.parseInt(id, 10) ===
                Number.parseInt(get(subGroupStudents, '[0]', null), 10),
            );
            return (
              <li key={assignmentId} data-test-id="progress-sections">
                <div className="flex flex-col justify-between items-start w-full font-medium">
                  <ProgressLink
                    sectionName={sectionName}
                    progressRoute={progressRoute.current}
                    assignmentId={assignmentId}
                    isAssessmentForm={isAssessmentForm}
                    isaNotation={
                      subGroupStudents.length === 1
                        ? `(${firstStudent?.firstName} ${firstStudent?.lastName})`
                        : subGroupStudents.length > 0
                          ? `(${subGroupStudents.length} students)`
                          : ''
                    }
                  />
                </div>
              </li>
            );
          },
        )}
      </ul>
    </div>
  );
};

export default AlreadyAssignedSection;
